//users.ts

import { apiProvider } from "./utilities/provider";
import { User } from "../../models/user";
import { JsonDocument } from "./utilities/json";

export const usersApi = {
  create: (
    name: string,
    email: string,
    password: string,
    turnstileToken: string,
  ) => apiProvider.post("users", { name, email, password, turnstileToken }),
  get: (): Promise<User> =>
    apiProvider.getAll("users").then((d: JsonDocument<User>) => d.data),
  archiveGrowerUser: (id: number): Promise<void> =>
    apiProvider.patch(`grower-users/${id}/archive`, undefined, {}),
};
